<template>
  <div class="content main-container">
    <div class="search-tools">
      <div class="search-box btn3">
        <div class="input-item">
          <span class="label">对账单名称</span>
          <Input v-model="searchParams.reconciliationName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">对账状态</span>
          <Select v-model="searchParams.reconciliationStatus" clearable>
            <Option value="0">未对账</Option>
            <Option value="1">对账正常</Option>
            <Option value="2">对账异常</Option>
            <Option value="3">已对账</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">对账日期</span>
          <DatePicker transfer v-model="searchParams.reconciliationDate" format="yyyy-MM-dd" type="date"
            placeholder="请选择"></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">核收人</span>
          <Input v-model="searchParams.reviewer" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">供应商类型</span>
          <RadioGroup v-model="searchParams.supplierType" @on-change="changeSupplierType">
            <Radio label="">全部</Radio>
            <Radio label="1">保险公司</Radio>
            <Radio label="2">合作通道</Radio>
          </RadioGroup>
        </div>
        <div class="input-item" v-if="searchParams.supplierType">
          <span class="label">供应商</span>
          <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4" clearable filterable transfer>
            <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="getList()">查询</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
        </div>
      </div>
    </div>
    <Button type="primary" style="margin-bottom: 20px;" @click="toPage">新建对账单</Button>
    <div class="table-box">
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row, index }" slot="reconciliationName">
          <div @click="lookStatement(row)" class="toDetailPage">
            {{ row.reconciliationName }}
          </div>
        </template>
        <template slot-scope="{ row }" slot="reconciliationStatusDesc">
          <div>
            <i class="dian red" v-if="row.reconciliationStatus == 2"></i>
            {{ row.reconciliationStatusDesc }}
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <div class="detail">
            <div @click="toDelete(row)" v-if="row.reconciliationStatus=='0'">
              <i class="iconfont iconshanchu"></i>
              <span>删除</span>
            </div>
            <div style="color: #A8ADB7;" v-else>
              <i class="iconfont iconshanchu"></i>
              <span>删除</span>
            </div>
          </div>
        </template>
      </Table>
      <div class="pageBox">
        <Page :total="total" :current="pageNo" :page-size="pageSize" show-total @on-change="pageChange"
          style="text-align: center" />
      </div>
    </div>
  </div>
</template>

<script>
import { pageTool,common } from "@/api/mixins";
import lzDicSelect from "@/components/commons/lzDicSelect";
export default {
  mixins: [pageTool,common],
  components: { lzDicSelect },
  data() {
    return {
      pageNo: 1,
      searchParams: {},
      supplierList: [],
      tableData: [],
      columns: [
        {
          title: "对账日期",
          align: "center",
          key: "reconciliationDate",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "对账单名称",
          align: "center",
          slot: "reconciliationName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "对账状态",
          align: "center",
          slot: "reconciliationStatusDesc",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "对账类型",
          align: "center",
          key: "reconciliationTypeDesc",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "总保费",
          align: "center",
          key: "premium",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "保单量",
          align: "center",
          key: "policyNum",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "批单量",
          align: "center",
          key: "billNum",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "费用",
          align: "center",
          key: "commission",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "签约供应商",
          align: "center",
          key: "supplierName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "签约机构",
          align: "center",
          key: "organizationName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "签约协议",
          align: "center",
          key: "agreementName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "核收人",
          align: "center",
          key: "reviewer",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 100,
          fixed: "right",
        },
      ],
    }
  },
  activated(){
    this.initListAjax("/buz/commissionReconciliation/groupPolicy/list")
  },
  methods: {
    setListParams(params){
      params.pageNo = this.pageNo
      params.reconciliationMonth = this.$units.formatDate(this.searchParams.reconciliationMonth, 'yyyy-MM')
      params.reconciliationDate = this.$units.formatDate(this.searchParams.reconciliationDate, 'yyyy-MM-dd')
    },
    lookStatement(row){
      this.openPageTabTags( '/offline/groupAccounts/detail',{ id: row.id,step:row.step }
      );
    },
    // 分页
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.getList(pageNo)
    },
    // 删除
    toDelete(row) {
      if(this.$units.pointAction('offline_8_3_3')){
        this.$notice.inquiry('确认删除操作？').then(async () => {
          this.$http({
            url: `/buz/commissionReconciliation/del?id=${row.id}`,
            type: 'GET'
          }).then(res => {
            this.$Message.success('删除成功');
            this.getList();
          });
        });
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
      
    },
    // 跳转对账单页面
    toPage(row) {
      if(this.$units.pointAction('offline_8_3_2')){
        this.openPageTabTags(
            '/offline/groupAccounts/add', 
            {
              id: row.id,
              t: Date.now()
            }
        );
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
      
    },
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.searchParams.supplierIds;
      this.supplierList = [];
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/all'
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list'
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then((res) => {
          this.supplierList = res.data;
        })
      }
      this.getList();
    },
  }
}
</script>

<style lang="scss" scoped>
.toDetailPage{
  color: #236DFF;
  cursor: pointer;
}
.dian {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: #35BF3F;
    border-radius: 50%;
    margin-right: 4px;
    &.red {
      background: #E3461F;
    }
  }
</style>